import { useQuery } from "@tanstack/react-query";
import Cookies from "universal-cookie";
import { getWithQueryApiServices } from "../apis/api";
import { apiRoutes } from "../apis/apiPath";
import { useOutletContext } from "react-router-dom";

export const useUserRole = (specificCompanyId = null) => {
  const cookies = new Cookies();
  const currentUserId = cookies.get("userId");
  const { currentCompany: globalCompany, tenantString } = useOutletContext() || {};
  
  const targetCompany = specificCompanyId || globalCompany;

  const { data: userData, isLoading } = useQuery({
    queryKey: ["userRoleDetect", currentUserId, targetCompany, tenantString],
    queryFn: () =>
      getWithQueryApiServices(
        apiRoutes.GET_ALL_USERS_LIST,
        `pageNumber=1&selectedCompany=${targetCompany || ""}${tenantString || ""}`
      ),
    enabled: !!currentUserId && !!targetCompany,
  });

  const rawTenantAdminCookie = cookies.get("isTenantAdmin");
  const rawSystemAdminCookie = cookies.get("isSystemAdmin");
  const isGlobalSuperAdmin = !!cookies.get("defaulttenant") || !!cookies.get("tenantList");

  const isTruthy = (val) =>
    val === true || val === "true" || val === 1 || val === "1" || val === "TRUE" || val === "yes";

  const isActualTenantAdmin = isTruthy(rawTenantAdminCookie);
  const isActualSystemAdmin = isTruthy(rawSystemAdminCookie);

  // Find current user in the list to get their company-specific roles
  const usersList = userData?.data?.userList || userData?.data || [];
  const currentUser = (Array.isArray(usersList) 
    ? usersList.find(u => Number(u.userID) === Number(currentUserId)) 
    : {}) || {};

  const isCompanyAdmin = isTruthy(currentUser.issysadm) || isTruthy(currentUser.isTenantAdmin);
  const isUserInCompany = isGlobalSuperAdmin || isActualTenantAdmin || !!currentUser.userID;

  const isCurrentUserSysAdmin =
    isGlobalSuperAdmin || isActualTenantAdmin || isCompanyAdmin;

  return {
    isGlobalSuperAdmin,
    isActualTenantAdmin,
    isActualSystemAdmin,
    isCompanyAdmin,
    isUserInCompany,
    isCurrentUserSysAdmin,
    isLoading,
  };
};
